import XLSX from 'xlsx';

export default {
  methods: {
    exportXLSParticipantes (eventoId, evento, participantes) {
      
      let wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Participantes",
        Subject: "Participantes",
        Author: "RegistrosPromocionales",
        CreatedDate: new Date()
      };

      let columns = [];

      if ((/true/i).test(evento.importaGanadores)) {
        columns.push('Posición');
      } else {
        columns.push('Nro.Orden');
      }
      if ((/true/i).test(evento.solicitaCodigoPromocion)) {
        columns.push('Cod.Promoción');
      }
      if ((/true/i).test(evento.solicitaNombre)) {
        columns.push('Nombre');
      }
      if ((/true/i).test(evento.solicitaDocumento)) {
        columns.push('Nro.Documento');
      }
      if ((/true/i).test(evento.solicitaDatosPersonales)) {
        columns.push('Fecha Nacim.');
        columns.push('Sexo');
      }
      if ((/true/i).test(evento.solicitaTelefono)) {
        columns.push('Nro.Celular');
      }
      if ((/true/i).test(evento.solicitaEmail)) {
        columns.push('Email');
      }
      if ((/true/i).test(evento.solicitaUbicacion)) {
        columns.push('Pais');
        columns.push('Provincia');
      }
      if ((/true/i).test(evento.solicitaLocalidad)) {
        columns.push('Localidad');
      }
      if ((/true/i).test(evento.solicitaBarrio)) {
        columns.push('Barrio');
      }
      if ((/true/i).test(evento.solicitaUbicacion)) {
        columns.push('Direccion');
        columns.push('Cod.Postal');
      }
      if ((/true/i).test(evento.requiereInformacionBancaria)) {
        columns.push('Banco');
        columns.push('CBU');
        columns.push('CBU Alias');
        columns.push('Titular Cuenta');
        columns.push('CUIT Titular');
      }
      if ((/true/i).test(evento.participacionNegocios)) {
        if ((/true/i).test(evento.solicitaPosicionNegocio)) {
          columns.push('Posición');
        }
        columns.push('Nombre Comercial');
        if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
          columns.push('Razón Social');
        }
        if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
          columns.push('CUIT');
        }
        if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
          columns.push('Pais');
          columns.push('Provincia');
        }
        if ((/true/i).test(evento.solicitaLocalidadNegocio)) {
          columns.push('Localidad'); 
        }
        if ((/true/i).test(evento.solicitaBarrioNegocio)) {
          columns.push('Barrio'); 
        }
        if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
          columns.push('Direccion');
          columns.push('Cod.Postal');
        }
      }
      /* Campos adicionales */
      if (evento.camposAdicionales) {
        evento.camposAdicionales.forEach(campoAdicional => {
          columns.push(campoAdicional.campo.trim());
        });
      }
      if (evento.tipoEventoId == 1) {
        columns.push('Confirmado');
        columns.push('Es Cliente');
        columns.push('Nro Cliente');
      }

      columns.push('Fecha Registro');

      let data = [ [] ];
      data.push([ ...columns ]);

      // console.log(data);

      participantes.forEach(participante => {
        let dataParticipante = [];

        if ((/true/i).test(evento.importaGanadores)) {
          dataParticipante.push(participante.posicionSorteo.toString().trim());
        } else {
          dataParticipante.push(participante.orden.toString().trim());
        }
        if ((/true/i).test(evento.solicitaCodigoPromocion)) {
          dataParticipante.push(participante.codigoPromocion.trim());
        }
        if ((/true/i).test(evento.solicitaNombre)) {
          dataParticipante.push(participante.nombreCompleto.trim());
        }
        if ((/true/i).test(evento.solicitaDocumento)) {
          dataParticipante.push(participante.documentoNumero.trim());
        }
        if ((/true/i).test(evento.solicitaDatosPersonales)) {
          dataParticipante.push(this.$options.filters.fecha(participante.fechaNacimiento));
          dataParticipante.push(participante.sexo.trim());
        }
        if ((/true/i).test(evento.solicitaTelefono)) {
          dataParticipante.push(participante.numeroCelular.trim());
        }
        if ((/true/i).test(evento.solicitaEmail)) {
          dataParticipante.push(participante.email.trim());
        }
        if ((/true/i).test(evento.solicitaUbicacion)) {
          dataParticipante.push(participante.pais.trim());
          dataParticipante.push(participante.provincia.trim());
        }
        if ((/true/i).test(evento.solicitaLocalidad)) {
          dataParticipante.push(participante.localidad.trim());
        }
        if ((/true/i).test(evento.solicitaBarrio)) {
          dataParticipante.push(participante.barrio.trim());
        }
        if ((/true/i).test(evento.solicitaUbicacion)) {
          dataParticipante.push(participante.direccion.trim());
          dataParticipante.push(participante.codigoPostal.trim());
        }
        if ((/true/i).test(evento.requiereInformacionBancaria)) {
          dataParticipante.push(participante.banco.trim());
          dataParticipante.push(participante.cbu.trim());
          dataParticipante.push(participante.cbuAlias.trim());
          dataParticipante.push(participante.titularCuenta.trim());
          dataParticipante.push(participante.titularCuit.trim());
        }
        if ((/true/i).test(evento.participacionNegocios)) {
          if (participante.negocio) {
            if ((/true/i).test(evento.solicitaPosicionNegocio)) {
              dataParticipante.push(participante.negocio.posicion.trim());
            }
            dataParticipante.push(participante.negocio.nombreComercial.trim());
            if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
              dataParticipante.push(participante.negocio.razonSocial.trim());
            }
            if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
              dataParticipante.push(participante.negocio.cuit.trim());
            }
            if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
              dataParticipante.push(participante.negocio.pais.trim());
              dataParticipante.push(participante.negocio.provincia.trim());
            }
            if ((/true/i).test(evento.solicitaLocalidadNegocio)) {
              dataParticipante.push(participante.negocio.localidad.trim()); 
            }
            if ((/true/i).test(evento.solicitaBarrioNegocio)) {
              dataParticipante.push(participante.negocio.barrio.trim()); 
            }
            if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
              dataParticipante.push(participante.negocio.direccion.trim());
              dataParticipante.push(participante.negocio.codigoPostal.trim());
            }
          } else {
            if ((/true/i).test(evento.solicitaPosicionNegocio)) {
              dataParticipante.push('');
            }
            dataParticipante.push('');
            if ((/true/i).test(evento.solicitaRazonSocialNegocio)) {
              dataParticipante.push('');
            }
            if ((/true/i).test(evento.solicitaDocumentoNegocio)) {
              dataParticipante.push('');
            }
            if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
              dataParticipante.push('');
              dataParticipante.push('');
            }
            if ((/true/i).test(evento.solicitaLocalidadNegocio)) {
              dataParticipante.push('');
            }
            if ((/true/i).test(evento.solicitaBarrioNegocio)) {
              dataParticipante.push('');
            }
            if ((/true/i).test(evento.solicitaUbicacionNegocio)) {
              dataParticipante.push('');
              dataParticipante.push('');
            }
          }
        }

        /* Campos adicionales */
        if (evento.camposAdicionales) {
          evento.camposAdicionales.forEach(campoAdicional => {
            if (participante.camposAdicionales) {
              var participanteCampoAdicional = participante.camposAdicionales.find(t => t.eventoCampoAdicionalId == campoAdicional.id);
              if (participanteCampoAdicional) {
                dataParticipante.push(participanteCampoAdicional.valor.trim());
              } else {
                dataParticipante.push('');
              }
            } else {
              dataParticipante.push('');
            }
          });
        }

        if (evento.tipoEventoId == 1) {
          dataParticipante.push((/true/i).test(participante.confirmado) ? 'SI' : 'NO');
          dataParticipante.push((/true/i).test(participante.esCliente) ? 'SI' : 'NO');
          dataParticipante.push(participante.numeroCliente);
        }
  
        dataParticipante.push(this.$options.filters.fechaHora(participante.fechaRegistro));

        data.push([ ...dataParticipante ]);
      });

      let ws = XLSX.utils.aoa_to_sheet(data);
      XLSX.utils.book_append_sheet(wb, ws, "Participantes");

      let xlsName = 'participantes_evento_'; 
      xlsName = xlsName.concat(eventoId.toString().trim());
      xlsName = xlsName.concat('.xlsx');
      XLSX.writeFile(wb, xlsName);

      return;
    },
  }
}
